import { DataBean } from "../DataBean";

export class TransportService extends DataBean {



    public async deleteTransportService(idTransportService: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTransportService_Number", [idTransportService]);
    }

    public async getTransportServiceCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTransportServiceCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}